<template>
  <div class="bt-anggota pa-5">
    <div>
      <v-card class="overflow-hidden elevation-3 rounded-lg mb-3">
        <v-card-text>
          <v-select label="Rembug" class="mb-4 font-weight-medium" hide-details :items="rembug" item-text="cm_name"
            item-value="cm_code" v-model="cm_code" readonly />
          <v-menu ref="menu" v-model="dateShow" :close-on-content-click="false" :return-value.sync="transaction_date"
            transition="scale-transition" offset-y min-width="auto" class="white" disabled>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="transaction_date" class="font-weight-medium" label="Tanggal" readonly
                v-bind="attrs" v-on="on" />
            </template>
            <v-date-picker v-model="transaction_date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateShow = false"> Cancel </v-btn>
              <v-btn text color="primary"> OK </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
      <v-text-field solo v-model="infaq" label="Infaq" type="number" v-mask="thousandMask" @focus="selectAll($event)"
        :rules="[() => !!infaq || 'This field is required']" />
      <v-row>
        <v-col cols="6" class="pb-0">
          <router-link :to="`/angsuran/kelompok/${cm_code}/${branch_id}/${transaction_date}`">
            <v-btn block class="purple lighten-1 white--text"> Kembali </v-btn>
          </router-link>
        </v-col>
        <v-col cols="6" class="pb-0">
          <v-btn block class="purple lighten-1 white--text" @click="doSave()">
            Simpan
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import Toast from "@/components/Toast";
import services from "@/services";
import helper from "@/utils/helper";
import { mapGetters } from "vuex";
import Header from "../../components/Header.vue";
export default {
  name: "AngsuranAnggota",
  components: {
    Toast,
    Header,
  },
  data() {
    return {
      rembug: [],
      cm_code: null,
      branch_id: null,
      transaction_date: null,
      dateShow: false,
      infaq: 0,
      alert: {
        show: false,
        msg: "",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...helper,
    selectAll(e) {
      setTimeout(() => {
        e.target.select();
      }, 50);
    },
    async getRembug() {
      try {
        let payload = new FormData();
        payload.append("fa_code", this.user.fa_code);
        payload.append("hari_transaksi", '99');

        this.$store.commit("setLoading", true);
        const response = await services.infoRembug(payload, this.user.token);
        if (response.status === 200) {
          if (Array.isArray(response.data.data)) {
            this.rembug = response.data.data;
          } else {
            this.$store.dispatch("showAlert", {
              show: false,
              msg: "",
            });
            setTimeout(() => {
              this.$store.dispatch("showAlert", {
                show: true,
                msg: `Kumpulan tidak ditemukan`,
                color: "warning",
                position: "top",
              });
            }, 50);
          }
        } else {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: data.message,
              color: "warning",
              position: "top",
            });
          }, 50);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 50);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
    async doSave() {
      this.$store.commit("setLoading", true);

      let payload = new FormData();

      payload.append('cm_code', this.cm_code);
      payload.append('transaction_date', this.transaction_date);
      payload.append('infaq', this.infaq);

      try {
        let req = await services.transactionInfaq(payload, this.user.token);
        if (req.data.status === true) {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: `Data berhasil dikirim`,
              color: "success",
              position: "top",
            });
          }, 50);

          setTimeout(() => {
            this.$router.push(`/angsuran/kelompok/${this.cm_code}/${this.branch_id}/${this.transaction_date}`);
          }, 1500);
        } else {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: req.data.message || `Data gagal dikirim`,
              color: "warning",
              position: "top",
            });
          }, 50);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 50);
      }

      this.$store.commit("setLoading", false);
    },
  },
  mounted() {
    this.cm_code = this.$route.params.cm_code;
    this.branch_id = this.$route.params.branch_id;
    this.transaction_date = this.$route.params.transaction_date;
    this.infaq = this.$route.params.infaq;

    this.getRembug();
  },
};
</script>
